export const qutationConstants = {
    GET_QUTATION: "GET_QUTATION_LIST",
    GET_QUTATION_SUCCESS: "GET_QUTATION_LIST_SUCCESS",
    GET_QUTATION_FAILURE: "GET_QUTATION_LIST_FAILURE",

    GET_WORKSPACE: "GET_WORKSPACE_LIST",
    GET_WORKSPACE_SUCCESS: "GET_WORKSPACE_LIST_SUCCESS",
    GET_WORKSPACE_FAILURE: "GET_WORKSPACE_LIST_FAILURE",

    GET_IGNORE_FILEDS: "GET_IGNORE_FILEDS_LIST",
    GET_IGNORE_FILEDS_SUCCESS: "GET_IGNORE_FILEDS_LIST_SUCCESS",
    GET_IGNORE_FILEDS_FAILURE: "GET_IGNORE_FILEDS_LIST_FAILURE",

    GET_QUTATION_BY_ID: "GET_QUTATION_BY_ID",
    GET_QUTATION_BY_ID_SUCCESS: "GET_QUTATION_BY_ID_SUCCESS",
    GET_QUTATION_BY_ID_FAILURE: "GET_QUTATION_BY_ID_FAILURE",

    CLONE_QUTATION: "CLONE_QUTATION_REQUEST",
    CLONE_QUTATION_SUCCESS: "CLONE_QUTATION_REQUEST_SUCCESS",
    CLONE_QUTATION_FAILURE: "CLONE_QUTATION_REQUEST_FAILURE",

    DELETE_QUTATION: "DELETE_QUTATION_REQUEST",
    DELETE_QUTATION_SUCCESS: "DELETE_QUTATION_REQUEST_SUCCESS",
    DELETE_QUTATION_FAILURE: "DELETE_QUTATION_REQUEST_FAILURE",

    GET_QUTATION_TEMPLATES: "GET_QUTATION_TEMPLATES",
    GET_QUTATION_TEMPLATES_SUCCESS: "GET_QUTATION_TEMPLATES_SUCCESS",
    GET_QUTATION_TEMPLATES_FAILURE: "GET_QUTATION_TEMPLATES_FAILURE",

    CREATE_QUOTATION_INIT: "CREATE_QUOTATION_INIT",
    CREATE_QUOTATION_SUCCESS: "CREATE_QUOTATION_SUCCESS",
    CREATE_QUOTATION_FAILURE: "CREATE_QUOTATION_FAILURE",

    UPDATE_QUOTATION_INIT: "UPDATE_QUOTATION_INIT",
    UPDATE_QUOTATION_SUCCESS: "UPDATE_QUOTATION_SUCCESS",
    UPDATE_QUOTATION_FAILURE: "UPDATE_QUOTATION_FAILURE",

    UPDATE_FOOTER_INIT: "UPDATE_FOOTER_INIT",
    UPDATE_FOOTER_SUCCESS: "UPDATE_FOOTER_SUCCESS",
    UPDATE_FOOTER_FAILURE: "UPDATE_FOOTER_FAILURE",

    GET_LOCATIONLIST_INIT: "GET_LOCATIONLIST_INIT",
    GET_LOCATIONLIST_SUCCESS: "GET_LOCATIONLIST_SUCCESS",
    GET_LOCATIONLIST_FAILURE: "GET_LOCATIONLIST_FAILURE",

    ADD_LOCATION_QUOTATION_INIT: "ADD_LOCATION_QUOTATION_INIT",
    ADD_LOCATION_QUOTATION_SUCCESS: "ADD_LOCATION_QUOTATION_SUCCESS",
    ADD_LOCATION_QUOTATION_FAILURE: "ADD_LOCATION_QUOTATION_FAILURE",

    CLONE_LOCATION: "CLONE_LOCATION",
    CLONE_LOCATION_SUCCESS: "CLONE_LOCATION_SUCCESS",
    CLONE_LOCATION_FAILURE: "CLONE_LOCATION_FAILURE",

    CLONE_GROUP: "CLONE_GROUP",
    CLONE_GROUP_SUCCESS: "CLONE_GROUP_SUCCESS",
    CLONE_GROUP_FAILURE: "CLONE_GROUP_FAILURE",

    EDIT_LOCATION_QUOTATION_INIT: "EDIT_LOCATION_QUOTATION_INIT",
    EDIT_LOCATION_QUOTATION_SUCCESS: "EDIT_LOCATION_QUOTATION_SUCCESS",
    EDIT_LOCATION_QUOTATION_FAILURE: "EDIT_LOCATION_QUOTATION_FAILURE",

    DELETE_LOCATION_QUOTATION_INIT: "DELETE_LOCATION_QUOTATION_INIT",
    DELETE_LOCATION_QUOTATION_SUCCESS: "DELETE_LOCATION_QUOTATION_SUCCESS",
    DELETE_LOCATION_QUOTATION_FAILURE: "DELETE_LOCATION_QUOTATION_FAILURE",

    GET_GROUPS_QUOTATION_INIT: "GET_GROUPS_QUOTATION_INIT",
    GET_GROUPS_QUOTATION_SUCCESS: "GET_GROUPS_QUOTATION_SUCCESS",
    GET_GROUPS_QUOTATION_FAILURE: "GET_GROUPS_QUOTATION_FAILURE",

    ADD_GROUP_QUOTATION_INIT: "ADD_GROUP_QUOTATION_INIT",
    ADD_GROUP_QUOTATION_SUCCESS: "ADD_GROUP_QUOTATION_SUCCESS",
    ADD_GROUP_QUOTATION_FAILURE: "ADD_GROUP_QUOTATION_FAILURE",

    UPDATE_GROUP_QUOTATION_INIT: "UPDATE_GROUP_QUOTATION_INIT",
    UPDATE_GROUP_QUOTATION_SUCCESS: "UPDATE_GROUP_QUOTATION_SUCCESS",
    UPDATE_GROUP_QUOTATION_FAILURE: "UPDATE_GROUP_QUOTATION_FAILURE",

    DELETE_GROUP_QUOTATION_INIT: "DELETE_GROUP_QUOTATION_INIT",
    DELETE_GROUP_QUOTATION_SUCCESS: "DELETE_GROUP_QUOTATION_SUCCESS",
    DELETE_GROUP_QUOTATION_FAILURE: "DELETE_GROUP_QUOTATION_FAILURE",

    CREATE_FOOTER_QUOTATION_INIT: "CREATE_FOOTER_QUOTATION_INIT",
    CREATE_FOOTER_QUOTATION_SUCCESS: "CREATE_FOOTER_QUOTATION_SUCCESS",
    CREATE_FOOTER_QUOTATION_FAILURE: "CREATE_FOOTER_QUOTATION_FAILURE",

    ADD_TERMS_QUOTATION_INIT: "ADD_TERMS_QUOTATION_INIT",
    ADD_TERMS_QUOTATION_SUCCESS: "ADD_TERMS_QUOTATION_SUCCESS",
    ADD_TERMS_QUOTATION_FAILURE: "ADD_TERMS_QUOTATION_FAILURE",

    GET_EXECUTIVES_INIT: "GET_EXECUTIVES_INIT",
    GET_EXECUTIVES_SUCCESS: "AGET_EXECUTIVES_SUCCESS",
    AGET_EXECUTIVES_FAILURE: "GET_EXECUTIVES_FAILURE",

    ADD_SALESEXE_QUOTATION_INIT: "ADD_SALESEXE_QUOTATION_INIT",
    ADD_SALESEXE_QUOTATION_SUCCESS: "ADD_SALESEXE_QUOTATION_SUCCESS",
    ADD_SALESEXE_QUOTATION_FAILURE: "ADD_SALESEXE_QUOTATION_FAILURE",

    PREVIEW_QUOTATION_INIT: "PREVIEW_QUOTATION_INIT",
    PREVIEW_QUOTATION_SUCCESS: "PREVIEW_QUOTATION_SUCCESS",
    PREVIEW_QUOTATION_FAILURE: "PREVIEW_QUOTATION_FAILURE",

    GENERATE_QUOTATION_INIT: "GENERATE_QUOTATION_INIT",
    GENERATE_QUOTATION_SUCCESS: "GENERATE_QUOTATION_SUCCESS",
    GENERATE_QUOTATION_FAILURE: "GENERATE_QUOTATION_FAILURE",

    GET_QUOTATION_STATUS: "GET_QUOTATION_STATUS",
    GET_QUOTATION_STATUS_SUCCESS: "GET_QUOTATION_STATUS_SUCCESS",
    GET_QUOTATION_STATUS_FAILURE: "GET_QUOTATION_STATUS_FAILURE",

    UPDATE_QUOTATION_STATUS: "UPDATE_QUOTATION_STATUS",
    UPDATE_QUOTATION_STATUS_SUCCESS: "UPDATE_QUOTATION_STATUS_SUCCESS",
    UPDATE_QUOTATION_STATUS_FAILURE: "UPDATE_QUOTATION_STATUS_FAILURE",

    GET_FOOTERLIST_INIT: "GET_FOOTERLIST_INIT",
    GET_FOOTERLIST_SUCCESS: "GET_FOOTERLIST_SUCCESS",
    GET_FOOTERLIST_FAILURE: "GET_FOOTERLIST_FAILURE",

    ADD_IGNORE_FIELDS_INIT: "ADD_IGNORE_FIELDS_INIT",
    ADD_IGNORE_FIELDS_SUCCESS: "ADD_IGNORE_FIELDS_SUCCESS",
    ADD_IGNORE_FIELDS_FAILURE: "ADD_IGNORE_FIELDS_FAILURE",

    GET_GROUP_PRODUCTS: "GET_GROUP_PRODUCTS",
    GET_GROUP_PRODUCTS_SUCCESS: "GET_GROUP_PRODUCTS_SUCCESS",
    GET_GROUP_PRODUCTS_FAILURE: "GET_GROUP_PRODUCTS_FAILURE",

    ADD_GROUP_PRODUCTS: "ADD_GROUP_PRODUCTS",
    ADD_GROUP_PRODUCTS_SUCCESS: "ADD_GROUP_PRODUCTS_SUCCESS",
    ADD_GROUP_PRODUCTS_FAILURE: "ADD_GROUP_PRODUCTS_FAILURE",

    ADD_GROUP_MERGE_PRODUCTS: "ADD_GROUP_MERGE_PRODUCTS",
    ADD_GROUP_MERGE_PRODUCTS_SUCCESS: "ADD_GROUP_MERGE_PRODUCTS_SUCCESS",
    ADD_GROUP_MERGE_PRODUCTS_FAILURE: "ADD_GROUP_MERGE_PRODUCTS_FAILURE",

    EDIT_GROUP_MERGE_PRODUCTS: "EDIT_GROUP_MERGE_PRODUCTS",
    EDIT_GROUP_MERGE_PRODUCTS_SUCCESS: "EDIT_GROUP_MERGE_PRODUCTS_SUCCESS",
    EDIT_GROUP_MERGE_PRODUCTS_FAILURE: "EDIT_GROUP_MERGE_PRODUCTS_FAILURE",

    DELETE_GROUP_PRODUCTS: "DELETE_GROUP_PRODUCTS",
    DELETE_GROUP_PRODUCTS_SUCCESS: "DELETE_GROUP_PRODUCTS_SUCCESS",
    DELETE_GROUP_PRODUCTS_FAILURE: "DELETE_GROUP_PRODUCTS_FAILURE",

    DELETE_GROUP_MERGE_PRODUCTS: "DELETE_GROUP_MERGE_PRODUCTS",
    DELETE_GROUP_MERGE_PRODUCTS_SUCCESS: "DELETE_GROUP_MERGE_PRODUCTS_SUCCESS",
    DELETE_GROUP_MERGE_PRODUCTS_FAILURE: "DELETE_GROUP_MERGE_PRODUCTS_FAILURE",

    ADD_MERGE_GROUP: "ADD_MERGE_GROUP",
    ADD_MERGE_GROUP_SUCCESS: "ADD_MERGE_GROUP_SUCCESS",
    ADD_MERGE_GROUP_FAILURE: "ADD_MERGE_GROUP_FAILURE",

    EDIT_MERGE_GROUP: "EDIT_MERGE_GROUP",
    EDIT_MERGE_GROUP_SUCCESS: "EDIT_MERGE_GROUP_SUCCESS",
    EDIT_MERGE_GROUP_FAILURE: "EDIT_MERGE_GROUP_FAILURE",

    CREATE_MERGE_GROUP: "CREATE_MERGE_GROUP",
    CREATE_MERGE_GROUP_SUCCESS: "CREATE_MERGE_GROUP_SUCCESS",
    CREATE_MERGE_GROUP_FAILURE: "CREATE_MERGE_GROUP_FAILURE",

    EDIT_MERGED_GROUP: "EDIT_MERGED_GROUP",
    EDIT_MERGED_GROUP_SUCCESS: "EDIT_MERGED_GROUP_SUCCESS",
    EDIT_MERGED_GROUP_FAILURE: "EDIT_MERGED_GROUP_FAILURE",

    DELETE_MERGE_GROUP: "DELETE_MERGE_GROUP",
    DELETE_MERGE_GROUP_SUCCESS: "DELETE_MERGE_GROUP_SUCCESS",
    DELETE_MERGE_GROUP_FAILURE: "DELETE_MERGE_GROUP_FAILURE",

    CLONE_MERGE_GROUP: "CLONE_MERGE_GROUP",
    CLONE_MERGE_GROUP_SUCCESS: "CLONE_MERGE_GROUP_SUCCESS",
    CLONE_MERGE_GROUP_FAILURE: "CLONE_MERGE_GROUP_FAILURE",

    DOWNLOAD_QUTATION: "DOWNLOAD_QUTATION_REQUEST",
    DOWNLOAD_QUTATION_SUCCESS: "DOWNLOAD_QUTATION_REQUEST_SUCCESS",
    DOWNLOAD_QUTATION_FAILURE: "DOWNLOAD_QUTATION_REQUEST_FAILURE",


    CHANGE_GROUP_QUOTATION_INIT: "CHANGE_GROUP_QUOTATION_INIT",
    UPDATE_GROUP_QUOTATION_INIT: "UPDATE_GROUP_QUOTATION_INIT",


    CLEAR_CUSTOMER_DETAILS: "CLEAR_CUSTOMER_DETAIL",
    CLEAR_QUOTATION_BODY: "CLEAR_QUOTATION_BODY",


    //  New Template form
    NEW_QUTATION_TEMPLATE: "NEW_QUTATION_TEMPLATE_REQUEST",
    NEW_QUTATION_TEMPLATE_SUCCESS: "NEW_QUTATION_TEMPLATE_REQUEST_SUCCESS",
    NEW_QUTATION_TEMPLATE_FAILURE: "NEW_QUTATION_TEMPLATE_REQUEST_FAILURE",

    UPDATE_QUTATION_TEMPLATE: "UPDATE_QUTATION_TEMPLATE_REQUEST",
    UPDATE_QUTATION_TEMPLATE_SUCCESS: "UPDATE_QUTATION_TEMPLATE_REQUEST_SUCCESS",
    UPDATE_QUTATION_TEMPLATE_FAILURE: "UPDATE_QUTATION_TEMPLATE_REQUEST_FAILURE",

    DELETE_QUTATION_TEMPLATE: "DELETE_QUTATION_TEMPLATE_REQUEST",
    DELETE_QUTATION_TEMPLATE_SUCCESS: "DELETE_QUTATION_TEMPLATE_REQUEST_SUCCESS",
    DELETE_QUTATION_TEMPLATE_FAILURE: "DELETE_QUTATION_TEMPLATE_REQUEST_FAILURE",

    CLEAR_NEW_FORM: "CLEAR_NEW_FORM",

    QUOTATION_CSV_DOWNLOAD: "QUOTATION_CSV_DOWNLOAD",
    QUOTATION_CSV_DOWNLOAD_SUCCESS: "QUOTATION_CSV_DOWNLOAD_SUCCESS",
    QUOTATION_CSV_DOWNLOAD_FAILURE: "QUOTATION_CSV_DOWNLOAD_FAILURE",
    CLEAR_CSV: "CLEAR_CSV",
    CLEAR_FOOTERLIST: "CLEAR_FOOTERLIST"

}